import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { MapOxxoTopicOne } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";

export class SceneTopicOne extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicOne(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}

	sceneActivityOneState() {
		this.characterMoveInitScene()

		this.characterSelected.position.set(-6.5874, -3, 4.5597);
		this.characterSelected.rotation.set(0, -0.8749, 0);

		this.mouseEvents.disposeInteractions()
		this.mouseEvents.objectsToValue = []
		this.mouseListeners()

	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		this.characterSelected.position.set(4.3, -3, 8.28);
		this.characterSelected.rotation.set(0, -1.398, 0);
		this.camera.control.maxAzimuthAngle = Infinity;
		this.camera.control.minAzimuthAngle = Infinity;

		ObserverEmitter.on(EVENTS.tema9.topic1.actScene, (step = "") => {
			switch (step) {
				case "touch_1":
					this.camera.moveCameraToPoint(new Vector3(14.2396, -0.5363, -1.9777), 0.5, new Vector3(13.31, -1.187, -0.751), () => {
					});
					let cajasName = []

					this.mouseEvents.objectsToValue = this.map.cajasActivityOne
					this.map.cajasActivityOne.forEach(caja => {
						this.map.onAnimate(caja)
						cajasName.push(caja.name)
					});

					this.mouseEvents.onPointerUp((interactions) => {
						let touch = false
						if (interactions[0]) {
							const name = interactions[0].object.name
							touch = cajasName.includes(name) ? true : false
						}

						if (touch) {
							this.map.cajasActivityOne.forEach(caja => {
								this.map.clearAnimation(caja)
							});
							setTimeout(() => {
								ObserverEmitter.emit(EVENTS.tema9.topic1.listenScene, "modal_1")
							}, 300);
						}
					});
					break;
				case "touch_2":
					this.camera.moveCameraToPoint(new Vector3(8.0129, 0.1032, 9.7058), 0.5, new Vector3(8.912, -0.121, 9.33), () => {
					});

					this.mouseEvents.objectsToValue = [this.map.Escalera]
					this.map.onAnimate(this.map.Escalera)
					this.mouseEvents.onPointerUp((interactions) => {
						let touch = false
						if (interactions[0]) {
							const name = interactions[0].object.name
							touch = name === this.map.Escalera.name ? true : false
						}

						if (touch) {
							this.map.clearAnimation(this.map.Escalera)
							setTimeout(() => {
								ObserverEmitter.emit(EVENTS.tema9.topic1.listenScene, "modal_2")
							}, 300);
						}
					});

					break;
				case "touch_3":
					this.camera.moveCameraToPoint(new Vector3(1.1857, -1.5174, 8.1259), 0.7, new Vector3(3.672, -1.329, 8.756), () => {
						this.map.Escalera.position.set(305, 415, 40)
						this.map.CajaEscalera1.position.set(305, 380, 138)
						this.map.CajaEscalera2.position.set(305, 450, 138)
					});
					// this.map.helpersChild()
					let objectNames = [
						this.map.Escalera.name,
						this.map.CajaEscalera1.name,
						this.map.CajaEscalera2.name,
					]
					this.map.onAnimate(this.map.Escalera)
					this.map.onAnimate(this.map.CajaEscalera1)
					this.map.onAnimate(this.map.CajaEscalera2)
					this.mouseEvents.objectsToValue = [
						this.map.Escalera,
						this.map.CajaEscalera1,
						this.map.CajaEscalera2,
					]


					this.mouseEvents.onPointerUp((interactions) => {
						let touch = false
						if (interactions[0]) {
							const name = interactions[0].object.name
							touch = objectNames.includes(name) ? true : false
						}

						if (touch) {
							this.map.clearAnimation(this.map.Escalera)
							this.map.clearAnimation(this.map.CajaEscalera1)
							this.map.clearAnimation(this.map.CajaEscalera2)
							setTimeout(() => {
								ObserverEmitter.emit(EVENTS.tema9.topic1.listenScene, "modal_3")
							}, 300);
						}
					});

					break;
				case "touch_4":
					this.camera.moveCameraToPoint(new Vector3(-12.5867, -2.3516, -5.6775), 1, new Vector3(-13.915, -2.326, -5.066), () => {
						this.map.Escalera.position.set(733.7207641601562, 503.8296203613281, 64.23954010009766)
						this.map.CajaEscalera1.position.set(773.575439453125, 397.2239990234375, -79.76390838623047)
						this.map.CajaEscalera2.position.set(769.8551025390625, 431.9478454589844, -79.76390075683594)
					});
					this.mouseEvents.objectsToValue = [this.map.CajaFuerte]
					this.map.onAnimate(this.map.CajaFuerte)
					this.mouseEvents.onPointerUp((interactions) => {
						let touch = false
						if (interactions[0]) {
							const name = interactions[0].object.name
							touch = name === this.map.CajaFuerte.name ? true : false
						}

						if (touch) {
							this.map.clearAnimation(this.map.CajaFuerte)
							setTimeout(() => {
								ObserverEmitter.emit(EVENTS.tema9.topic1.listenScene, "modal_4")
							}, 300);
						}
					});
					break;
				case "return":
					this.characterSelected.position.set(-12.3, -3, -5.8);
					this.characterSelected.rotation.set(0, 1.88, 0);
					this.camera.moveCameraToPoint(new Vector3(-11.4603, -2.8061, -6.1837), 1, new Vector3(-13.938, -2.709, -5.098), () => {
					});
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	sceneActivityThreeState() {
		this.characterMoveInitScene()

		this.characterSelected.position.set(4.3, -3, 8.28);
		this.characterSelected.rotation.set(0, -1.398, 0);

		this.mouseEvents.objectsToValue = []
		this.mouseEvents.disposeInteractions()
		this.mouseListeners()
	}

	sceneActivityFourState() {
		this.characterMoveInitScene()

		this.characterSelected.position.set(4.3, -3, 8.28);
		this.characterSelected.rotation.set(0, -1.398, 0);

		this.mouseEvents.objectsToValue = []
		this.mouseEvents.disposeInteractions()
		this.mouseListeners()
	}

	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-7.5596, -2.7062, 5.5432), 1, new Vector3(-6.786, -2.86, 4.877), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.ennablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(3.3811, -2.7859, 8.2659), 1, new Vector3(4.48, -2.645, 8.298), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityTwoState();
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(3.3811, -2.7859, 8.2659), 1, new Vector3(4.48, -2.645, 8.298), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityThreeState();
				});
				break;
			case 4:
				this.camera.moveCameraToPoint(new Vector3(3.3811, -2.7859, 8.2659), 1, new Vector3(4.48, -2.645, 8.298), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityFourState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// const name = interactions[0].object.name;
				// ObserverEmitter.emit(EVENTS.tema3.listenClick, name);
			}
		});
	}

	renderAnimations(delta) {
	}
}
